import { MeSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agenciesKeys } from '@/queries/agencies/keys';
import { apiClient } from '@/stores/api/apiClient';
import { meKeys } from './keys';

export function useSetActiveAgency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (agencyId: string) => apiClient.post<ApiResponse<MeSchema>>('/v1/me', { agencyId }),
    onSuccess: (response) => {
      if (!response?.data) return;
      queryClient.setQueryData(meKeys.all, { ...response.data, policies: response.policies ?? [] });
      if (response.data.agency) {
        queryClient.setQueryData(agenciesKeys.item(response.data.agency.id), response.data.agency);
      }
    },
  });
}
